'use strict';

function isPositiveInterval(timestampInterval) {
  return timestampInterval.end > timestampInterval.start;
}

module.exports = isPositiveInterval;
//# sourceMappingURL=isPositiveInterval.cjs.map
